export default {
  methods: {
    entityEdit: (createElement, entity, entityName) =>
      createElement("entity-edit-control", {
        attrs: {
          entity,
          entityName,
        },
      }),
    entityDelete: (createElement, entity, entityName, refs) =>
      createElement("entity-delete-control", {
        attrs: {
          entity,
          entityName,
          refs,
        },
      }),
    entityActionSet: (createElement, entity, entityName, refs) =>
      createElement("entity-action-set", {
        attrs: {
          entity,
          entityName,
          refs,
        },
      }),
  },
};
